import React from 'react';
import { RouterProvider } from 'react-router/dom';
import { router } from '@/router/router';
import { AuthGate } from '@/auth/AuthGate';
import { LogoutSync } from '@/auth/LogoutSync';
import { UserProvider } from '@/auth/UserContext';
import { AbsenceApplicationProvider } from '@/components/AbsenceApplication/AbsenceApplicationProvider';
import { EvaluationModalProvider } from '@/components/EvaluationModal/EvaluationModalProvider';
import { ProfileRestrictionProvider } from '@/components/ProfileRestriction/ProfileRestrictionProvider';

export const App: React.FC = () => (
  <AuthGate>
    <LogoutSync />
    <UserProvider>
      <ProfileRestrictionProvider>
        <AbsenceApplicationProvider>
          <EvaluationModalProvider>
            <RouterProvider router={router} />
          </EvaluationModalProvider>
        </AbsenceApplicationProvider>
      </ProfileRestrictionProvider>
    </UserProvider>
  </AuthGate>
);
